import { ZoomInOutlined } from "@ant-design/icons";
import { Table } from "antd";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { productosInventarioStartLoading } from "../../actions/inventario";
import { ButtonUi } from "../ui/ButtonUi";
import { TipoButtonConstants } from "../../types/typesConstants";
import { InventarioLoteSerieModal } from "./InventarioLoteSerieModal";
import { CantidadColumn } from "../ui";

const columns = (acciones) => {
  const { handleShowModalAdicionales } = acciones;
  return [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      width: "5%",
      render: (text, record, i) => <>{i + 1}</>,
    },
    {
      title: "Producto",
      dataIndex: "nombreproducto",
      key: "nombreproducto",
    },
    {
      title: "Almacén",
      dataIndex: "nombrealmacen",
      key: "nombrealmacen",
    },
    {
      title: "Stock",
      dataIndex: "stockactual",
      key: "stockactual",
      align: "right",
      render: (_, record) => (
        <>
          <CantidadColumn
            cantidad={record.stockactual}
            unidadmedida_nombre={record.unidadmedida_prefijo}
          />
        </>
      ),
    },
    {
      title: "Adicionales",
      dataIndex: "adicionales",
      key: "adicionales",
      align: "center",
      render: (_, record) => (
        <>
          {record?.manejalotes && (
            <ButtonUi
              typeUi={TipoButtonConstants.CustomButton}
              icon={<ZoomInOutlined />}
              text="Lotes"
              onClick={() => handleShowModalAdicionales(record)}
            />
          )}
          {record?.manejaseries && (
            <ButtonUi
              typeUi={TipoButtonConstants.CustomButton}
              icon={<ZoomInOutlined />}
              text="Series"
              onClick={() => handleShowModalAdicionales(record)}
            />
          )}
        </>
      ),
    },
  ];
};

export const InventarioProductoTable = ({ data, loading, paginator }) => {
  const dispatch = useDispatch();
  const [inventario, setInventario] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const handleShowModalAdicionales = (data) => {
    setInventario(data);
    setOpenModal(true);
  };
  const handleCloseModal = () => setOpenModal(false);
  const handleLoadData = (page = 1, page_size = 10) => {
    let searchFormData = JSON.parse(localStorage.getItem("SearhFormTable"));
    searchFormData = { ...searchFormData, page, page_size };
    dispatch(productosInventarioStartLoading(searchFormData));
  };
  return (
    <>
      <Table
        size="small"
        className="ui-table"
        bordered
        columns={columns({
          handleShowModalAdicionales,
        })}
        dataSource={data}
        rowKey="id"
        loading={loading}
        scroll={{ x: 550 }}
        pagination={{
          align: "start",
          showSizeChanger: true,
          total: paginator?.count,
          onChange: (page, page_size) => handleLoadData(page, page_size),
          showTotal: (total) => {
            const xTotal = data?.length > 0 ? total : 0;
            return `Total ${xTotal} items`;
          },
        }}
      />
      <InventarioLoteSerieModal
        inventario={inventario}
        open={openModal}
        handleCancelModal={handleCloseModal}
      />
    </>
  );
};
